import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ChatbotRoleLookup {
  getRoleCode$(): Observable<string | null>;
}

/** Host-provided role lookup that can load the user's roles when IndexedDB is empty. */
export const CHATBOT_ROLE_LOOKUP = new InjectionToken<ChatbotRoleLookup>('CHATBOT_ROLE_LOOKUP');

/** Chat endpoint URL, overridable by the host application. */
export const CHATBOT_CHAT_API_URL = new InjectionToken<string>('CHATBOT_CHAT_API_URL');

/** Conversation endpoint URL, overridable by the host application. */
export const CHATBOT_CONVERSATION_API_URL = new InjectionToken<string>('CHATBOT_CONVERSATION_API_URL');
